export default function MailerLiteIframe() {
  return (
    <iframe
      src="https://preview.mailerlite.io/forms/1585326/168985630600070697/share"
      style={{
        width: "100%",
        height: "400px",
        border: "none",
        overflow: "hidden",
      }}
      
    ></iframe>
  );
}
